"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../../utils");

var _getIsAdmin = require("ui-addon-upgrades/_core/common/eligibility/getIsAdmin");

var _AdminPrompt = require("ui-addon-upgrades/_core/common/components/AdminPrompt");

var _AdminTypes = require("ui-addon-upgrades/_core/common/constants/AdminTypes");

var _AdminModalTypes = _interopRequireDefault(require("ui-addon-upgrades/_core/common/constants/AdminModalTypes"));

var AdminOnlyWrapper =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AdminOnlyWrapper, _Component);

  function AdminOnlyWrapper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AdminOnlyWrapper);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AdminOnlyWrapper).call(this, props));
    _this.state = {
      isAdmin: false
    };
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AdminOnlyWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var adminType = this.props.adminType;
      (0, _getIsAdmin.getIsAdmin)(adminType).then(function (isAdmin) {
        return _this2.setState({
          isAdmin: isAdmin
        });
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          modalType = _this$props.modalType,
          merchandiseId = _this$props.merchandiseId,
          quoteLink = _this$props.quoteLink;
      return (0, _AdminPrompt.AdminPrompt)({
        modalType: modalType,
        merchandiseId: merchandiseId,
        quoteLink: quoteLink
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isAdmin = this.state.isAdmin;
      var children = this.props.children;

      var child = _react.Children.only(children);

      if (!isAdmin) {
        var newProps = (0, _utils.omit)((0, _extends2.default)({}, child.props, {
          onClick: this.handleClick
        }), 'href');
        return _react.default.createElement(child.type, newProps);
      }

      return child;
    }
  }]);
  return AdminOnlyWrapper;
}(_react.Component);

AdminOnlyWrapper.defaultProps = {
  adminType: _AdminTypes.TEAM,
  modalType: _AdminModalTypes.default.DEFAULT
};
AdminOnlyWrapper.propTypes = {
  adminType: _react.PropTypes.oneOf([_AdminTypes.BILLING, _AdminTypes.TEAM]).isRequired,
  children: _react.PropTypes.node.isRequired,
  merchandiseId: _react.PropTypes.number,
  modalType: _react.PropTypes.oneOf(Object.values(_AdminModalTypes.default || {})),
  quoteLink: _react.PropTypes.string
};
var _default = AdminOnlyWrapper;
exports.default = _default;
module.exports = exports.default;